module.exports = __webpack_public_path__ + "img/kleisma3m.a1390fe3.webp";